import _ from 'lodash'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ViewMode, DeviceType } from '@/types/pricolle'


const STORE_ID = 'UIStateStore'


export const useStore = defineStore(STORE_ID, {
  state() {
    return {
      /**
       * 表示モード
       */
      viewMode: undefined as ViewMode,

      /**
       * デバイス種別
       */
      deviceType: undefined as DeviceType,

      /**
       * 表示中の Modal コンポーネントの UUID を格納する配列
       */
      shownModals: [] as string[],

      /**
       * ページスクロール抑制の要請元コンポーネントの UUID を格納する配列
       */
      scrollLockers: [] as string[],
    }
  },


  getters: {
    /**
     * 表示中の Modal コンポーネントがひとつでもあれば true
     */
    hasShownModals(): boolean {
      return this.shownModals.length > 0
    },

    /**
     * ページスクロール抑制の要請元コンポーネントがひとつでもあれば true
     */
    hasScrollLockers(): boolean {
      return this.scrollLockers.length > 0
    },
  },


  actions: {
    /**
     * 表示モード値を変更する
     * @param viewMode  表示モード
     */
    updateViewMode(viewMode: ViewMode) {
      this.viewMode = viewMode
    },

    /**
     * デバイス種別値を変更する
     * @param deviceType  デバイス種別
     */
    updateDeviceType(deviceType: DeviceType) {
      this.deviceType = deviceType
    },

    /**
     * 表示中の Modal コンポーネントの UUID を追加
     * @param uuid  Modal コンポーネントの UUID
     */
    appendShownModal(uuid: string): void {
      this.removeShownModal(uuid)
      this.shownModals.push(uuid)
    },

    /**
     * 表示中の Modal コンポーネントの UUID を削除
     * @param uuid  Modal コンポーネントの UUID
     */
    removeShownModal(uuid: string): void {
      this.shownModals = _.without(this.shownModals, uuid)
    },

    /**
     * ページスクロール抑制を要請する
     * @param uuid  要請元コンポーネントの UUID
     */
    requestScrollLock(uuid: string): void {
      this.cancelScrollLock(uuid)
      this.scrollLockers.push(uuid)
    },

    /**
     * ページスクロール抑制の要請を解除する
     * @param uuid  要請元コンポーネントの UUID
     */
    cancelScrollLock(uuid: string): void {
      this.scrollLockers = _.without(this.scrollLockers, uuid)
    },
  },
})


// Hot Module Replacement
// NOTE: Pinia の HMR について→ https://pinia.vuejs.org/cookbook/hot-module-replacement.html
// FIXME: しかし動作しない感じ→ https://github.com/vuejs/pinia/discussions/1072
const hot = /* import.meta.hot */ import.meta.webpackHot
if (hot) {
  hot.accept(acceptHMRUpdate(useStore, hot))
}

